import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { FmParticipant } from './participant';
import { FmRecordings } from './recordings';

export class FmRoom extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public createdTimestamp: string;

  @Expose()
  public updatedTimestamp: string;

  @Expose()
  public name: string;

  @Expose()
  public description: string;

  @Expose()
  public publicToken: string;

  @Expose()
  public sid: string;

  @Expose()
  public roomType: string;

  @Expose()
  public duration: number;

  @Expose()
  public status: string;

  @Expose()
  public maxDuration: number;

  @Expose()
  public maxParticipants: number;

  @Expose()
  public record: boolean;

  @Expose()
  public emptyRoomTimeout: number;

  @Expose()
  public unusedRoomTimeout: number;

  @Expose()
  public participants: FmParticipant[];

  @Expose()
  public owner: string;

  @Expose()
  public publicJoinLink: string;

  @Expose()
  public recordings: FmRecordings[];

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
